export const EditorImageExtensions: string[] = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'tiff', 'tif', 'svg'];
